import { render, staticRenderFns } from "./DetalleEntregaLibroItem.vue?vue&type=template&id=1e0916cc&"
import script from "./DetalleEntregaLibroItem.vue?vue&type=script&lang=js&"
export * from "./DetalleEntregaLibroItem.vue?vue&type=script&lang=js&"
import style0 from "./DetalleEntregaLibroItem.vue?vue&type=style&index=0&id=1e0916cc&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports